export function fireCustomGEvent(data) {
  if (typeof window === "undefined") return
  if (typeof window.gtag !== "function") return

  window.gtag("event", "click", { ...data })
}
